import client from 'graphql/client';
import { gql } from '@apollo/client';
import { fetchProfile } from 'services/fetchProfile';
import { ToolExecutionResult } from '../types';

const GET_AUTH_USER = gql`
  query AIChatAuthUser {
    authUser {
      emailAddress
    }
  }
`;

export const executeGetUserProfile = async (): Promise<ToolExecutionResult> => {
  try {
    // First get the user's email from GraphQL
    const authResult = await client.query({
      query: GET_AUTH_USER,
      fetchPolicy: 'network-only',
    });

    const email = authResult.data?.authUser?.emailAddress;

    if (!email) {
      return {
        success: false,
        error: 'Unable to retrieve user email. Please ensure you are logged in.',
      };
    }

    // Then fetch the full profile from HubSpot
    const profileResponse = await fetchProfile({ email });

    if (!profileResponse) {
      return {
        success: true,
        data: {
          email,
          message: 'Basic profile found. Extended profile information not available.',
        },
      };
    }

    return {
      success: true,
      data: {
        profile: {
          email,
          firstName: profileResponse.firstName,
          lastName: profileResponse.lastName,
          fullName:
            profileResponse.firstName && profileResponse.lastName
              ? `${profileResponse.firstName} ${profileResponse.lastName}`
              : null,
          dateOfBirth: profileResponse.dateOfBirth,
          address: {
            line1: profileResponse.addressline1,
            line2: profileResponse.addressline2,
            line3: profileResponse.addressline3,
            city: profileResponse.city,
            state: profileResponse.state,
            postCode: profileResponse.postCode,
            country: profileResponse.country,
          },
          accountStatus: profileResponse.cwLeadStatus,
        },
      },
    };
  } catch (error) {
    return {
      success: false,
      error: `Failed to fetch user profile: ${(error as Error).message}`,
    };
  }
};
